import React, { useState } from 'react';

import DeleteModal from 'components/DeleteModal/DeleteModal';
import Close from 'components/Icons/Close';

const Delete: React.FC<{ confirmed; description }> = ({ confirmed, description }) => {
  const [deleteModal, setDeleteModal] = useState<boolean>(false);

  return (
    <div className="delete-container">
      <div onClick={() => setDeleteModal(true)}>
        <Close fontSize={18} />
      </div>

      {deleteModal && (
        <DeleteModal
          openModal={deleteModal}
          handleModal={() => {
            setDeleteModal(!deleteModal);
          }}
          handleCloseModal={() => {
            setDeleteModal(!deleteModal);
          }}
          generalMessage={description}
          handleDelete={confirmed}
        />
      )}
    </div>
  );
};

export default Delete;
